/* global axios */
import ApiClient from './ApiClient';

class IntegrahubSalesAPI extends ApiClient {
  constructor() {
    // accountScoped so baseUrl becomes /api/v1/accounts/:id/integrahub_sales
    super('integrahub_sales', { accountScoped: true });
  }

  create({ payload, conversationId, contactId } = {}) {
    const body = { payload };
    if (conversationId) body.conversation_id = conversationId;
    if (contactId) body.contact_id = contactId;
    if (typeof window !== 'undefined' && window.axios) {
      return window.axios.post(this.url, body);
    }
    return axios.post(this.url, body);
  }
}

export default new IntegrahubSalesAPI();
